import React from 'react';
import PropTypes from 'prop-types';
import InfoCard from 'partial/components/InfoCard';
import messages from 'assets/images/icons/messages.svg';
import organizations from 'assets/images/icons/organization.svg';
import integration from 'assets/images/icons/integration.svg';
import mask from 'assets/images/icons/mask.svg';
import {
  useTotalInteg,
  useTotalMasks,
  useTotalMsgs,
  useTotalOrgs,
} from '../hooks';

const loader = <div className="bg-gray-50 animate-pulse h-[150px]" />;

function Icon({ type }) {
  const which = {
    messages,
    organizations,
    integration,
    mask,
  };
  return <img src={which[type]} alt={type} />;
}

Icon.propTypes = {
  type: PropTypes.string.isRequired,
};

function Cards() {
  const [isMsgLoading, msgData] = useTotalMsgs();
  const [isOrgsLoading, orgsData] = useTotalOrgs();
  const [isIntegLoading, integData] = useTotalInteg();
  const [isMaskLoading, masksData] = useTotalMasks();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      <InfoCard
        label="TOTAL MESSAGES"
        total={msgData?.total_messages || '0'}
        icon={<Icon type="messages" />}
        image
        isLoading={isMsgLoading}
        loader={loader}
      />
      <InfoCard
        label="TOTAL ORGANIZATIONS"
        total={orgsData?.total_organization || '0'}
        icon={<Icon type="organizations" />}
        isLoading={isOrgsLoading}
        image
        loader={loader}
      />
      <InfoCard
        label="TOTAL INTEGRATION"
        total={integData?.total_api_keys || '0'}
        icon={<Icon type="integration" />}
        isLoading={isIntegLoading}
        image
        loader={loader}
      />
      <InfoCard
        label="MASK NAMES"
        total={masksData?.total_messages || '0'}
        icon={<Icon type="mask" />}
        isLoading={isMaskLoading}
        image
        loader={loader}
      />
    </div>
  );
}

export default Cards;
